import { Field, ErrorMessage } from "formik"
import { useEffect, useRef } from "react"

const TextField = (props) => {
  const inputRef = useRef(null)
  const {
    name,
    label = "",
    placeholder = "",
    type = "text",
    autofocus = false,
  } = props

  useEffect(() => {
    if (inputRef.current && autofocus) {
      inputRef.current.focus()
    }
  }, [inputRef, autofocus])

  return (
    <div className="w-full">
      <label className="ml-1 mb-1 text-sm" htmlFor={name}>
        {label}
      </label>
      <Field
        className="w-full outline-0 focus:border-secondary border border-slate-300 p-2 rounded-lg text-gray-900 ring-gray-300 placeholder:text-gray-400"
        id={name}
        innerRef={(el) => {
          inputRef.current = el ?? null
        }}
        name={name}
        placeholder={placeholder}
        type={type}
      />
      <ErrorMessage name={name}>
        {(msg) => <p className="text-rose-500 text-xs ml-2 mt-1">{msg}</p>}
      </ErrorMessage>
    </div>
  )
}

export default TextField
